import { render } from "./HelpMfaSettingJa.vue?vue&type=template&id=f972c5e2"
const script = {}

import "./HelpMfaSettingJa.vue?vue&type=style&index=0&id=f972c5e2&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__